import Base from './base'

export default class VisualizationsTracking extends Base {
  track(data: object) {
    return this.apiClient.post('track-visualizations', data)
  }
}
